<template>
  <div>
    <input type="button" value="扫一扫" id="scanQRCode" />
    <van-overlay v-show='true'>
      <div class="wrapper" @click.stop>
        <div class="wra_block">
          <div class="block_tit">商贷利率</div>
          <div>
              <img src="" alt="">
          </div>
          <div class="block_btn">
            <p @click="show = false">我知道了</p>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  data() {
    return {
        page1:"",
        page2:""
    };
  },
  created() {},
  methods: {
    wx() {
      this.$http
        .post(
          "cms/wechat/permit/doShare.do",
          qs.stringify({
            url: window.location.href,
          })
        )
        .then((res) => {
          wx.config({
            debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.obj.appId, // 必填，公众号的唯一标识
            timestamp: res.obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.obj.nonceStr, // 必填，生成签名的随机串
            signature: res.obj.signature, // 必填，签名，见附录1
            // jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            jsApiList: ["checkJsApi", "scanQRCode"],
          });

          wx.ready(function () {
            wx.checkJsApi({
              jsApiList: ["scanQRCode"],
              success: function (res) {},
            });

            //点击按钮扫描二维码
            document.querySelector("#scanQRCode").onclick = function () {
              wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                  var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                  alert("扫描结果：" + result);
                  //   window.location.href = result; //因为我这边是扫描后有个链接，然后跳转到该页面
                },
              });
            };
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.wra_block {
  border-radius: 5px;
  width: 4.5rem;
  height: 6rem;
  color: #000;
  background: #fff;
  padding: 0.2rem 0.3rem;
  .block_tit {
    padding: 0.2rem 0;
    font-size: 0.3rem;
    font-weight: 900;
  }
  .block_btn {
    margin-top: 0.8rem;
    padding: 0 1.5rem;
    p {
      padding: 0.1rem 0;
      background: #007fff;
      border-radius: 5px;
      text-align: center;
      color: #fff;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
